import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { formatDollarAmount, formatNumberWithCommas } from '~/utils/number-formatting';
import { DiscountPeriodExpirationModel } from './DiscountPeriodExpirationModel';
export var DiscountType = /*#__PURE__*/ function(DiscountType) {
    DiscountType["Value"] = "value";
    DiscountType["Percent"] = "percent";
    return DiscountType;
}({});
export var DiscountDTOType = /*#__PURE__*/ function(DiscountDTOType) {
    DiscountDTOType["Percent"] = "percent";
    DiscountDTOType["Value"] = "value";
    DiscountDTOType["None"] = "none";
    return DiscountDTOType;
}({});
export class DiscountModel {
    static make(type, amount, expiration) {
        return new DiscountModel({
            type,
            amount: new Decimal(amount),
            expiration
        });
    }
    static makePercent(amount, expiration) {
        return DiscountModel.make("percent", amount, expiration);
    }
    static makeValue(amount, expiration) {
        return DiscountModel.make("value", amount, expiration);
    }
    static fromDTO(dto) {
        if (dto == null) return null;
        switch(dto.type){
            case "percent":
                {
                    const expirationData = dto.expirationV2;
                    return new DiscountModel({
                        type: "percent",
                        amount: new Decimal(dto.temp_amount).div(100),
                        expiration: expirationData ? DiscountPeriodExpirationModel.fromDTO(expirationData) : undefined
                    });
                }
            case "value":
                {
                    const expirationData = dto.expirationV2;
                    return new DiscountModel({
                        type: "value",
                        amount: new Decimal(dto.temp_amount).div(100),
                        expiration: expirationData ? DiscountPeriodExpirationModel.fromDTO(expirationData) : undefined
                    });
                }
            case "none":
                return null;
        }
    }
    static fromDBDTO(dto) {
        if (!dto || dto.type === "none") return null;
        const expiration = dto.expiration ? DiscountPeriodExpirationModel.fromDBDTO(dto.expiration) : undefined;
        return new DiscountModel({
            type: dto.type === "percent" ? "percent" : "value",
            amount: new Decimal(dto.decimal).div(100),
            expiration
        });
    }
    toDTO() {
        return _object_spread({
            type: this.discount.type === "percent" ? "percent" : "value",
            amount: this.discount.amount.toNumber(),
            temp_amount: this.discount.amount.mul(100).toNumber()
        }, this.discount.expiration && {
            expirationV2: this.discount.expiration.toDTO()
        });
    }
    toDBDTO() {
        return _object_spread({
            type: this.discount.type === "percent" ? "percent" : "value",
            decimal: this.discount.amount.mul(100).toNumber()
        }, this.discount.expiration && {
            expiration: this.discount.expiration.toDBDTO()
        });
    }
    type() {
        return this.discount.type;
    }
    isPercent() {
        return this.discount.type === "percent";
    }
    isValue() {
        return this.discount.type === "value";
    }
    isSameAs(other) {
        return this.discount.type === other.discount.type && this.discount.amount.equals(other.discount.amount);
    }
    amount() {
        return this.discount.amount;
    }
    accept(visitor) {
        switch(this.discount.type){
            case "value":
                return visitor.whenValue();
            case "percent":
                return visitor.whenPercent();
        }
    }
    format() {
        let { showValueAsNegative } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return this.discount.type === "value" ? formatDollarAmount(showValueAsNegative ? this.discount.amount.neg() : this.discount.amount) : "".concat(formatNumberWithCommas(this.discount.amount), "%");
    }
    setExpiration(expiration) {
        return new DiscountModel(_object_spread_props(_object_spread({}, this.discount), {
            expiration: expiration !== null && expiration !== void 0 ? expiration : DiscountPeriodExpirationModel.makeNone()
        }));
    }
    expiration() {
        return this.discount.expiration;
    }
    constructor(discount){
        _define_property(this, "discount", void 0);
        this.discount = discount;
    }
}
